/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable no-bitwise */

'use strict';

var addressHelpers = require('./address');
var shippingHelpers = require('./shipping');
var billingHelpers = require('./billing');
var summaryHelpers = require('./summary');
var formHelpers = require('./formErrors');
var scrollAnimate = require('base/components/scrollAnimate');
var addressTypes = ['shipping'];
var utils = require('../utils');
var clientSideValidation = require('../components/clientSideValidation');
var cvsHelpers = require('./convenienceStore');
var loqateAddress = require('./loqateAddress');
var loqateKeyboard = require('./loqateKeyboard');
var klarnaOsm = require('../common/klarnaOsm');
var peachCheckout = require('./peachCheckout');

var shippingAddressOneLoqate = '#shippingAddressOneLoqate';

var { loadUrl } = require('../utils');

/**
 * Function to invoke the shipping methods from the server on click of edit button or the browser back button
 * @returns {void}
 */
var getShippingMethods = function () {
    var url = $('.edit-shipping').data('shipping-methods-url');
    $.ajax({
        url: url,
        method: 'POST',
        success: function (data) {
            if ($('.shipping-address').find('.alert').is(':visible')) {
                $('.shipping-address').find('.alert').css('display', 'none');
            }
            shippingHelpers.methods.updateShippingMethods(data.shipping[0]);
            if (window.sitePrefs.accessPoint) {
                var $shipping = $('.shipping-content');
                if ($shipping.hasClass('shipping-type-access-point')) {
                    $shipping.find('.field-shipping-access-point').prop('checked', true);
                    $shipping.find('.field-shipping-regular').prop('checked', false);
                    if (!$('.shipping-address-block').is(':visible')) {
                        $('.shipping-address-block').css('display', 'block');
                    }
                    $shipping.find('.shippingAddressOne').parent().css('display', 'none');
                    $shipping.find('.shippingAddressTwo').parent().css('display', 'none');
                    $shipping.find('.shippingAddressCity').parent().css('display', 'none');
                    $shipping.find('.shippingZipCode').parent().css('display', 'none');
                    $shipping.find('.access-point-message').css('display', 'block');
                    $shipping.find('.access-point').css('display', 'block');
                    if ($('.shipping-address-block').hasClass('d-none')) {
                        $('.shipping-address-block').removeClass('d-none');
                    }
                    if ($('.shipment-selector-block').length > 0) {
                        $('.shipment-selector-block').addClass('d-none');
                    }
                    if ($('.save-address-to-NB').length > 0) {
                        $('.save-address-to-NB').addClass('d-none');
                        $shipping.find('#saveShippingAddr').prop('checked', false);
                    }
                    if ($('.border-add-address').length > 0) {
                        $('.border-add-address').addClass('d-none');
                    }

                    if ($shipping.find('.access-point-message').hasClass('d-none')) {
                        $shipping.find('.access-point-message').removeClass('d-none');
                    }
                    if ($shipping.find('.access-point').hasClass('d-none')) {
                        $shipping.find('.access-point').removeClass('d-none');
                    }
                    $shipping.find('.access-points-no-results').hide();
                    $shipping.find('.access-points-results').show();
                    $shipping.find('.access-points-list-header').show();
                    $shipping.find('.access-points-list').show();
                } else if ($shipping.hasClass('shipping-type-regular')) {
                    $shipping.find('.field-shipping-regular').prop('checked', true);
                    $shipping.find('.field-shipping-access-point').prop('checked', false);
                }
            }
        },
        error: function () {
        }
    });
};

/**
 * Only call dynamic dropdown functions one time so select options do not get refiltered
 * @param {Function} e function intended to only run once
 * @returns {Function} function for single call
*/
function dropdownSingleCall(e) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            return e.apply(this, arguments);
        }
        return null;
    };
}

/**
 * Filter shipping address dropdown options when dependent on other dropdown fields
*/
var handleDynamicShippingDropdowns = dropdownSingleCall(function () {
    var shippingCityDropdown = $('.dynamic-shippingcity');
    if (shippingCityDropdown.length > 0) {
        var shippingStateDropdown = $('#shippingState');
        var shippingCityOptions = shippingCityDropdown.find('option');
        var selectedShippingCity = shippingCityDropdown.val();
        shippingCityDropdown.removeAttr('value');

        // On change of shipping region/state dropdown
        shippingStateDropdown.on('change', function () {
            // CVS shipping will inject the form fields making this unnecessary
            if (!$('.shipping-content').hasClass('shipping-type-cvs')) {
                shippingCityDropdown.html(shippingCityOptions.filter('[data-region="' + this.value + '"]'));
                if (selectedShippingCity) {
                    shippingCityDropdown.prepend($("<option value=''></option>"));
                } else {
                    shippingCityDropdown.prepend($("<option value='' selected></option>"));
                    shippingCityDropdown.val('');
                }
                selectedShippingCity = '';

                if ($('.shipping-type-boss').length && $('.boss-store.store-selected').length) {
                    var storeCity = $('.boss-store.store-selected').data('bossStoreCity');
                    shippingCityDropdown.val(storeCity).trigger('change');
                } else {
                    shippingCityDropdown.trigger('change');
                }
            }
        }).trigger('change');
    }
    var shippingZipDropdown = $('.dynamic-shippingzip');
    if (shippingZipDropdown.length > 0) {
        // Get the field the dynamic zip field depends on
        var dependsOnID = '#shippingAddress' + utils.capitalizeFirstLetter(shippingZipDropdown.attr('data-dependson'));
        var shippingDependencyDropdown = $(dependsOnID);
        var selectedShippingZip = shippingZipDropdown.val();
        if (shippingDependencyDropdown.length > 0) {
            if (selectedShippingZip && selectedShippingZip !== 'null') {
                shippingZipDropdown.removeAttr('value');
            }
            shippingDependencyDropdown.on('change', function () {
                var matchingZipOption = shippingZipDropdown.find('[data-' + shippingZipDropdown.attr('data-dependson') + '="' + this.value + '"]');
                if (matchingZipOption.length > 0 && matchingZipOption.val() !== null && matchingZipOption.val() !== 'null') {
                    shippingZipDropdown.val(matchingZipOption.val()).trigger('change');
                } else {
                    // Did not find a match, clear out
                    shippingZipDropdown.val('').trigger('change');
                }
            });
        }
    }
});

/**
 * Filter billing address dropdown options when dependent on other dropdown fields
*/
var handleDynamicBillingDropdowns = dropdownSingleCall(function () {
    var shippingStateDropdown = $('#shippingState');
    var shippingCityDropdown = $('.dynamic-shippingcity');
    var billingCityDropdown = $('.dynamic-billingcity');
    var billingZipDropdown = $('.dynamic-billingpostalCode');
    var shippingZipDropdown = $('.dynamic-shippingzip');
    if (billingCityDropdown.length > 0) {
        var billingStateDropdown = $('#billingstateCode');
        var billingCityOptions = billingCityDropdown.find('option');
        var selectedBillingCity = billingCityDropdown.val();
        billingCityDropdown.removeAttr('value');

        // On change of billing region/state dropdown
        billingStateDropdown.on('change', function () {
            billingCityDropdown.html(billingCityOptions.filter('[data-region="' + this.value + '"]'));
            if (selectedBillingCity) {
                billingCityDropdown.prepend($("<option value=''></option>"));
            } else {
                billingCityDropdown.val('');
                billingCityDropdown.prepend($("<option value='' selected></option>"));
            }
            selectedBillingCity = '';
            billingCityDropdown.trigger('change');
        }).trigger('change');

        // On change of 'Same as shipping address' checkbox
        $('#shippingAddressUseAsBillingAddress').on('change', function () {
            if ($('#shippingAddressUseAsBillingAddress').is(':checked')) {
                // select state, filter cities and select city
                billingStateDropdown.prop('value', shippingStateDropdown.val());
                $('#billingstateCode option:selected').removeAttr('selected');
                $('#billingstateCode option[value="' + shippingStateDropdown.val() + '"]').prop('selected', true);
                billingCityDropdown.html(billingCityOptions.filter('[data-region="' + shippingStateDropdown.val() + '"]'));
                billingCityDropdown.prepend($("<option value=''></option>"));
                $('.dynamic-billingcity option[value="' + shippingCityDropdown.val() + '"]').prop('selected', true);
                // select postal code
                if (billingZipDropdown.length > 0) {
                    $('.dynamic-billingpostalCode option[value="' + shippingZipDropdown.val() + '"]').prop('selected', true);
                }
            }
        });
    }

    if (billingZipDropdown.length > 0) {
        // Get the field the dynamic zip field depends on
        var dependsOnID = '#billing' + billingZipDropdown.attr('data-dependson');
        var billingDependencyDropdown = $(dependsOnID);
        if (billingDependencyDropdown.length > 0) {
            billingZipDropdown.removeAttr('value');
            billingDependencyDropdown.on('change', function () {
                var matchingZipOption = billingZipDropdown.find('[data-' + billingZipDropdown.attr('data-dependson') + '="' + this.value + '"]');
                if (matchingZipOption.length > 0 && matchingZipOption.val() !== null && matchingZipOption.val() !== 'null') {
                    billingZipDropdown.val(matchingZipOption.val()).trigger('change');
                } else {
                    // Did not find a match, clear out
                    billingZipDropdown.val('').trigger('change');
                }
            });
        }
    }
});

/**
 * format address based on country standards
 * @param {Object} addressData - object containing address data
 * @returns {string} formatted address
 */
function formatAddress(addressData) {
    var usePunctuation = $('#checkout-main').data('punctuation');
    var useSpaces = $('#checkout-main').data('spaces');
    var fullAddress = '';
    var addressOrder = $('#checkout-main').data('addressorder').split(',');

    for (var i = 0; i < addressOrder.length; i += 1) {
        var item = addressOrder[i];
        var value = addressData.data(item);
        if (value) {
            var noComma = item === 'stateCode' || item === 'postalCode' || !usePunctuation;
            fullAddress += value + (noComma ? '' : ',') + (useSpaces ? ' ' : '');
        }
    }

    return fullAddress;
}

/**
 * Set Default Values on the custom dropdown
 * @param {string} data - custom dropdown changes
 * @param {string} shippingOrBilling - 'shipping' for shipping, 'billing' for billing
*/
function setDefaultValues(data, shippingOrBilling) {
    var firstName1 = data.data('firstName');
    var lastName1 = data.data('lastName');
    var name = window.sitePrefs.nameOrderFormat === 'lastfirst' ? lastName1 + ' ' + firstName1 : firstName1 + ' ' + lastName1;
    var defaultValue = '<div class="text-start pe-6 px-lg-3 name-address-wrapper">'
        + '<span class="display-name d-block">' + name + '</span>'
        + '<span class="address-line">' + formatAddress(data) + '</span>'
        + '</div>';

    $('.custom-dropdown.' + shippingOrBilling + 'AddressSelector .selected-option').empty().append(defaultValue);
    $('.custom-dropdown.' + shippingOrBilling + 'AddressSelector .custom-selection-list').attr('aria-expanded', false);
}

/**
 * update selcted address
 * @param {Object} e event object
 * @param {string} addressType "shipping" or "billing"
 */
function updateSelectedAddress(e, addressType) {
    var eventType = e.type;
    var eventKeyCode = e.keyCode || e.which;
    var $this = $(e.currentTarget);
    if (eventType === 'click' || eventKeyCode === utils.ENTER_KEY_CODE) {
        var $customSelectionList = $this.parent('.custom-selection-list');
        var index1 = 0;
        $.each($this.children(), function () {
            index1 = $this.data('id');
        });
        $this.closest('.custom-dropdown.' + addressType + 'AddressSelector').find('select option').removeAttr('selected');
        $this.closest('.custom-dropdown.' + addressType + 'AddressSelector').find('select option:eq(' + index1 + ')').attr('selected', 'selected')
            .trigger('change');

        $('.' + addressType + 'AddressSelector .custom-selection-list').removeClass('show');
        var selectedOption = $('.' + addressType + 'AddressSelector .' + addressType + '-dropdown option:selected');
        var firstSelectedOption = $(selectedOption[0]);
        if (firstSelectedOption.length && firstSelectedOption.data('firstName')) {
            setDefaultValues(firstSelectedOption, addressType);
        }
        $('.add-update-address').removeClass('d-none');
        $('.custom-dropdown.' + addressType + 'AddressSelector .selected-option').removeClass('active');
        $this.attr('aria-selected', true);
        if ($customSelectionList.length) {
            $customSelectionList.attr('aria-activedescendant', $this.attr('id'));
        }
    }
}

/**
 * Set Default Values on the custom dropdown
*/
function getDefaultValues() {
    var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';
    if (isAmzPayExpressFlow) {
        return;
    }
    var selectedOption1 = $('.custom-dropdown.billingAddressSelector .billing-dropdown option:selected');

    if (selectedOption1.val() === 'new' || selectedOption1.val() === 'manual-entry') {
        $.each($('.custom-dropdown.billingAddressSelector').find('select').children(), function () {
            if (!$(this).prop('disabled') && $(this).val() !== 'new') {
                $(this).attr('selected', 'selected');
                setDefaultValues($(this), 'billing');
                return false;
            }
            return true;
        });
    } else {
        setDefaultValues($(selectedOption1[0]), 'billing');
    }
}

/**
 * Focus selected option in the custom dropdown
 * @param {Object} $selectedOption Jquery element object
 */
function focusSelectedOption($selectedOption) {
    if ($selectedOption.length) {
        var $customSelectionList = $selectedOption.next('.custom-selection-list');
        if ($customSelectionList.length) {
            var $selectedAddressRadio = $customSelectionList.find('input[type="radio"]:checked');
            if ($selectedAddressRadio.length) {
                var $selectedListItem = $selectedAddressRadio.parents('.list-item');
                $selectedListItem.focus();
            }
        }
    }
}

/**
 * Address Dropdown items KeyDown
 * @param {Object} $target event object
 * @param {boolean} isDownArrowKey down arrow key
 */
function onListItemKeyDown($target, isDownArrowKey) {
    var $customSelectionList = $target.parent('.custom-selection-list');
    if ($customSelectionList.length) {
        var totalItems = $customSelectionList.children('li').length;
        var selectedItemIndex = $customSelectionList.children('li').index($target);

        if (selectedItemIndex !== -1) {
            if (isDownArrowKey && totalItems > 1 && selectedItemIndex < totalItems) {
                selectedItemIndex += 1;
            } else if (!isDownArrowKey && selectedItemIndex > 0) {
                selectedItemIndex -= 1;
            }

            var $nextFocusItem = $customSelectionList.find('li').eq(selectedItemIndex);
            if ($nextFocusItem.length && $customSelectionList.length) {
                $nextFocusItem.focus();
                $customSelectionList.attr('aria-activedescendant', $nextFocusItem.attr('id'));
            }
        }
    }
}

/**
 * close custom list
 * @param {Object} $target jquery element object
 */
function closeCustomList($target) {
    var $customDropdown = $target.parents('.custom-dropdown');
    if ($customDropdown.length) {
        var $selectedOption = $customDropdown.find('.selected-option');
        var $selectedCardDisplay = $customDropdown.find('.selected-card-display');
        $selectedOption.removeClass('active');
        $selectedCardDisplay.removeClass('active');
        $customDropdown.removeClass('active');
    }
}

/**
 * Show Terms & Conditions
 */
function showTermsConditions() {
    var $termsConditionsContent = $('.terms-conditions-content');
    var $termsCheckbox = $('.terms-cond-checkbox');
    if ($termsConditionsContent.length) {
        $termsConditionsContent.removeClass('d-none');
        $termsConditionsContent.find('.invalid-feedback').empty();
    }

    if ($termsCheckbox.length) {
        $termsCheckbox.prop('checked', false);
    }
}

/**
 * toggle user payments
 * @param {boolean} hasSavedPayments true/false
 */
function showSavedPaymentInstruments(hasSavedPayments) {
    var $userPaymentInstruments = $('.user-payment-instruments');
    var $creditCardForm = $('.credit-card-form');
    if ($userPaymentInstruments.length && hasSavedPayments) {
        $userPaymentInstruments.removeClass('checkout-hidden');
        $creditCardForm.addClass('checkout-hidden');
    } else {
        $userPaymentInstruments.addClass('checkout-hidden');
        $creditCardForm.removeClass('checkout-hidden');
    }
}

/**
 * Validate Peach Payments form fields
 * @param {Object} $form peach form to validate
 * @returns {boolean} is form valid
 */
function validatePeachForm($form) {
    var $fields = $form.find('input, select');
    var $iframe = $form.find('iframe');
    var errorClass = 'wpwl-has-error';
    var valid = true;

    var cardNumberIsValid = $('#peach-payment-form input[name=\'isSecurityCodeValid\']').val() === 'true';
    var securityCodeIsValid = $('#peach-payment-form input[name=\'isSecurityCodeValid\']').val() === 'true';
    if (!securityCodeIsValid || !cardNumberIsValid) {
        valid = false;
    }

    if ($fields.length) {
        for (var i = 0; i < $fields.length; i += 1) {
            var $field = $fields.eq(i);
            if ($field.is(':visible') && (!$field.val() || $field.hasClass(errorClass))) {
                valid = false;
                break;
            }
        }
    }

    if ($iframe.length && $iframe.first().hasClass(errorClass)) {
        valid = false;
    }

    return valid;
}

/**
 * Execute the Peach Payments form
 */
function submitPeachForm() {
    var peachFormContainer = window.wpwl.form.containerKey;
    window.wpwl.executePayment(peachFormContainer);
}

/**
 * Handles the Amazon Pay Express place order flow.
 * @param {Object} data - The data object containing the redirect URL.
 * @param {string} data.amzPlaceOrderRedirectUrl - The URL to redirect the user to for the Amazon Pay Express place order flow.
 */
function handleAmazonPayExpressPlaceOrderFlow(data) {
    window.location.href = data.amzPlaceOrderRedirectUrl;
}

/**
 * Hides specified payment methods on the billing page
 * @param {array} paymentMethodsToHide - The array containing payment method IDs to hide
 */
function hidePaymentMethods(paymentMethodsToHide) {
    if (!paymentMethodsToHide) return;

    paymentMethodsToHide.forEach(function (method) {
        var $methodTab = $('[data-method-id="' + method + '"]');
        $methodTab.removeClass('d-flex');
        $methodTab.addClass('d-none');
        if ($methodTab.find('a.nav-link').hasClass('active')) {
            $methodTab.find('a.nav-link').removeClass('active');
            $('#selectedPaymentOption').val('');
        }
    });
}

/**
 * Create the jQuery Checkout Plugin.
 *
 * This jQuery plugin will be registered on the dom element in checkout.isml with the
 * id of "checkout-main".
 *
 * The checkout plugin will handle the different state the user interface is in as the user
 * progresses through the varying forms such as shipping and payment.
 *
 * Billing info and payment info are used a bit synonymously in this code.
 *
 */
(function ($) {
    $.fn.checkout = function () { // eslint-disable-line
        var plugin = this;

        //
        // Collect form data from user input
        //
        var formData = {
            // Shipping Address
            shipping: {},

            // Billing Address
            billing: {},

            // Payment
            payment: {},

            // Gift Codes
            giftCode: {}
        };

        //
        // The different states/stages of checkout
        //
        var checkoutStages = [
            'shipping',
            'payment',
            'placeOrder',
            'submitted'
        ];

        // Page Title
        var $pageTitle = $('.page-title');

        // Checkout main
        var $checkoutMain = $('#checkout-main');

        /**
         * Updates the URL to determine stage
         * @param {number} currentStage - The current stage the user is currently on in the checkout
         */
        function updateUrl(currentStage) {
            window.history.pushState(
                checkoutStages[currentStage],
                document.title,
                window.location.pathname
                + '?stage='
                + checkoutStages[currentStage]
                + '#'
                + checkoutStages[currentStage]
            );
        }

        /**
        * Selects the payment method
        */
        function selectPaymentMethod() {
            var $paymentOptions = $('.js_payment-options a[data-toggle="tab"]');
            var selectedMethodID = $('.payment-information').data('payment-method-id');
            var $deafultPaymentOption = $paymentOptions.first();

            // make sure we dont select apple pay as default
            if ($deafultPaymentOption.hasClass('applepay-tab')) {
                $deafultPaymentOption = $paymentOptions.eq(1);
            }

            $paymentOptions.each(function (index, paymentOption) {
                var $paymentOption = $(paymentOption);
                var methodID = $(paymentOption).parent().data('method-id');
                var paymentTabContent = $paymentOption.attr('href');
                var $paymentTabContent = $(paymentTabContent);
                $paymentOption.removeClass('active');
                $paymentTabContent.removeClass('active');
                $paymentTabContent.find('input, textarea, select').removeAttr('disabled');
                if (methodID === selectedMethodID) {
                    $deafultPaymentOption = $paymentOption;
                }
            });
            if (members.currentStage === 1) {  // eslint-disable-line
                $deafultPaymentOption.trigger('click');
            }
            $('.submit-payment').removeClass('d-none');
        }

        /**
         * Fill the dummy card details into GC fields
         * @param {string} data - The dummy clutch card details
         */
        function applyClutchGiftCard(data) {
            if (data.clutchCardDetailsResult !== undefined && data.clutchCardDetailsResult.success !== undefined
                && !data.clutchCardDetailsResult.success && !data.clutchCardDetailsResult.isClutchAllotmentMember
                && !data.clutchCardDetailsResult.isClutchBalanceExists) {
                $('#giftCertID').val('');
                $('#giftCertPin').val('');
                $('#redeem-another-card').trigger('click');
            } else if (data.clutchCardDetailsResult.success && data.clutchCardDetailsResult.isClutchBalanceExists) {
                $('#giftCertID').val(data.clutchCardDetailsResult.cardNumber);
                $('#giftCertPin').val(data.clutchCardDetailsResult.cardPin);
                $('#add-gift-card-btn').trigger('click');
                $('#giftCertID').val('');
                $('#giftCertPin').val('');
                $('#redeem-another-card').trigger('click');
            // eslint-disable-next-line sonarjs/no-duplicated-branches
            } else {
                $('#giftCertID').val('');
                $('#giftCertPin').val('');
                $('#redeem-another-card').trigger('click');
            }
        }

        /**
         * Disable COD payment option
         * @param {Object} $codTab - The cash-on-delivery-tab
         */
        function disableCOD($codTab) {
            if ($codTab.hasClass('active')) {
                $codTab.removeClass('active');
                $('#selectedPaymentOption').val('');
            }
            $codTab.addClass('disabled');
            $('.overlimit-msg').removeClass('d-none');
        }

        // Hide the clutch avaliable balance if the page is not shipping
        $(window).on('load', function () {
            var currentStage = window.location.search.substring(window.location.search.indexOf('=') + 1);
            if (currentStage === ('payment' || 'placeOrder')) {
                $('.gmp-ordersummary').addClass('d-none');
                $('#giftCertID').val('');
                $('#giftCertPin').val('');
                $('#redeem-another-card').trigger('click');
            }
        });

        // show the clutch avaliable balance when user navigates back to shipping page from billing and bal should be > 0
        $('.edit-shipping').on('click', function () {
            var clutchBal = $('.clutch-used').text().split('.')[0].substring('1', '2');
            if (clutchBal !== '0') {
                $('.gmp-ordersummary').removeClass('d-none');
            }
        });

        $('body').on('checkout:checkCODlimit', function (e, paymentAmt) {
            var codLimit = window.sitePrefs.codTransactionLimit;
            var $codTab = $('.cash-on-delivery-tab');

            if (paymentAmt && $codTab.length > 0) {
                if (paymentAmt > codLimit) {
                    disableCOD($codTab);
                } else {
                    $codTab.removeClass('disabled');
                    $('.overlimit-msg').addClass('d-none');
                }
            }
        });

        /**
         * call the submit shipping url
         * @param {string} submitShippingURL - The submitShippingURL
         * @param {Object} shippingFormData - The shippingFormData
         * @param {boolean} isShippingFieldsVisible - The isShippingFieldsVisible
         * @param {Object} $shippingSummaryHeader - The shippingSummaryHeader
         * @param {Object} defer - The defer
         */
        function callSubmitShippingURL(submitShippingURL, shippingFormData, isShippingFieldsVisible, $shippingSummaryHeader, defer) {
            $.ajax({
                url: submitShippingURL,
                type: 'post',
                data: shippingFormData,
                success: function (data) {
                    import(/* webpackPrefetch: true */'../zipCodes').then(function (zipCodes) {
                        var postalCode = $('.shippingZipCode').val();
                        var country = $('.shippingCountry').val();
                        var zipCodeSelector = '.shipping-address-block .shippingZipCode';
                        var isZipCodeValid = true;
                        if (country && postalCode) {
                            isZipCodeValid = utils.isZipCodeValid(postalCode, country, zipCodeSelector, zipCodes.zipCodeJSON);
                        }
                        if (!isZipCodeValid || data.applicableShippingMethodsLength === 0) {
                            // If shipping fields are not visible, user will not see zip code error
                            // Display a generic error message instead
                            if (!isShippingFieldsVisible) {
                                $('.error-message').show();
                                $('.error-message-text').text($('#addressValidationMessage').val());
                            }
                            $.spinner().stop();
                            scrollAnimate($(zipCodeSelector));
                            return;
                        }

                        var billingContainerPaypal = $('.paypal-billing-container');
                        if (billingContainerPaypal.length) {
                            var shippingEmail = $('#shippingEmail').val();
                            $('#paypalOrderCustom').val(shippingEmail);
                        }

                        // enable the next:Payment button here
                        $('body').trigger('checkout:enableButton', '.next-step-button button');
                        shippingHelpers.methods.shippingFormResponse(defer, data);

                        var isBopisOrder = $('#checkout-main').hasClass('bopis-only-order');
                        var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';

                        if (data.isAccessPointLocationID || data.isYamatoPickup || isBopisOrder || data.isBossStoreID || isAmzPayExpressFlow) {
                            $('#shippingAddressUseAsBillingAddress').parent('.email-add').addClass('d-none');
                            $('.billingAddressSelector').addClass('d-none');
                            if (!$('.billing-address').is(':visible')) {
                                billingHelpers.methods.clearBillingAddressFormValues();
                                $('.billing-address').addClass('d-block');
                                $('#shippingAddressUseAsBillingAddress').prop('checked', false).trigger('change');
                            }
                        } else {
                            if ($('.billing-address').hasClass('d-block')) {
                                $('.billing-address').removeClass('d-block');
                            }
                            if ($('.billingAddressSelector').hasClass('d-none')) {
                                $('#shippingAddressUseAsBillingAddress').parent('.email-add').removeClass('d-none');
                                $('.billingAddressSelector').removeClass('d-none');
                            }
                        }

                        getDefaultValues();
                        if (data.order && data.order.totals && data.order.totals.grandTotalValue) {
                            $('body').trigger('checkout:checkCODlimit', data.order.totals.grandTotalValue);
                        }

                        // hide payment methods that are not available after shipping details submitted
                        if (data.paymentMethodsToHide) {
                            hidePaymentMethods(data.paymentMethodsToHide);
                        }
                        // reset credit card form
                        billingHelpers.methods.clearCreditCardForm();
                        selectPaymentMethod();
                        if ($('#shippingAddressUseAsBillingAddress').is(':checked')) {
                            $('#shippingAddressUseAsBillingAddress').trigger('change'); // to update the shipping addres on billing page.
                        } else {
                            $('.billing-address').removeClass('d-none').addClass('d-block');
                            $('.js-billingAddressSelector').addClass('d-none');
                        }
                        // reset payment option selection
                        // For logged in user reset CVV
                        if (data.customer && data.customer.registeredUser) {
                            $('.show-cvv-input.selected-payment .saved-payment-security-code').val('').removeAttr('disabled');

                            if (data.customer.customerPaymentInstruments.length) {
                                showSavedPaymentInstruments(true);
                            } else {
                                showSavedPaymentInstruments();
                            }
                        }

                        if ($shippingSummaryHeader) {
                            scrollAnimate($shippingSummaryHeader);
                        }

                        if (data.isOrderGiftCardCovered !== undefined && !data.isOrderGiftCardCovered) {
                            $('.entire-order-reedemed').remove();
                            selectPaymentMethod();
                        }

                        // Invoking the clutch service for normal product or mixed cart and also for BOPIS product
                        if (data.customer && data.customer.registeredUser) {
                            // Updating the clutch dummy card details into gift card field when user navigating from shipping to billing page
                            applyClutchGiftCard(data);
                        }

                        if (data.order && data.order.isGiftCertificateRemoved) {
                            var paymentMethodSection = $('.payment-container');
                            var $giftPromoSection = $('.gift-promo-section');
                            // The order still needs to be paid for with other payment methods
                            $giftPromoSection.find('.card-body').removeClass('collapse').addClass('show');
                            $giftPromoSection.find('.plus').removeClass('collapsed').attr('aria-expanded', true);
                            $giftPromoSection.find('.minus').removeClass('collapsed').attr('aria-expanded', true);

                            paymentMethodSection.removeClass('d-none');
                            selectPaymentMethod();
                            $('.payment-information').data('payment-method-id', 'CREDIT_CARD');
                            $('#gift-payment-methods .giftcard-payment-instrument').each(function (i, el) {
                                $(el).remove();
                            });
                            $('.entire-order-reedemed').remove();
                            $('#gift-payment-methods').append('<span class="gc-removed-msg font-error">'
                                + data.order.resources.giftCardRemoved + '</span>');
                            $('.afterpay-item').toggleClass('d-none', billingHelpers.methods.orderHasPaymentMethodInstrument(data.order, 'GIFT_CERTIFICATE'));
                            var $gcform = $('form#gift-card-form');
                            if ($gcform && $gcform.length > 0) {
                                $gcform.find('#giftCertID').val('');
                                $gcform.find('#giftCertPin').val('');
                                $('.apply-balance-check').removeClass('d-none');
                                $('.redeem-another-card').addClass('d-none');
                            }
                            $('.credit-card-form').find('.form-control').removeClass('is-invalid');
                        } else if ($('#gift-payment-methods .gc-removed-msg') && $('#gift-payment-methods .gc-removed-msg').length > 0) {
                            $('#gift-payment-methods .gc-removed-msg').remove();
                            $('.credit-card-form').find('.form-control').removeClass('is-invalid');
                        }
                        $.spinner().stop();
                        if ($('#showMobileAcc').hasClass('show')) {
                            $('.showMore').trigger('click');
                        }
                    });
                },
                error: function (err) {
                    // enable the next:Payment button here
                    $('body').trigger('checkout:enableButton', '.next-step-button button');
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    // Server error submitting form
                    defer.reject(err.responseJSON);
                    $.spinner().stop();
                }
            });
        }

        /**
         * Prevent COD if Yamato Pickup selected
         */
        function preventYamatoCOD() {
            var $cod = $('[data-method-id="CASH_ON_DELIVERY"]');

            if ($cod.length) {
                if ($('.shipping-type-yamato').length) {
                    if ($cod.hasClass('d-flex')) {
                        $cod.removeClass('d-flex');
                        $cod.addClass('d-none');
                        $cod.data('preventCOD', true);
                    }
                } else {
                    $cod.removeClass('d-none');
                    $cod.addClass('d-flex');
                    $cod.data('preventCOD', false);
                }
            }
        }

        /**
         * Prevent Yamato Pickup if COD selected
         */
        function preventYamatoPickup() {
            var $cod = $('[data-method-id="CASH_ON_DELIVERY"]');

            if ($cod.length) {
                var paymentSelection = $('[name="dwfrm_billing_paymentMethod"]').val();
                var $pickupEle = $('#shipping-type-selector-yamato').parent();
                if (paymentSelection === 'CASH_ON_DELIVERY') {
                    $pickupEle.addClass('d-none');
                } else {
                    $pickupEle.removeClass('d-none');
                }
            }
        }

        /**
         * call the submit email validation url
         * @param {string} emailValidationUrl - The emailValidationUrl
         * @returns {boolean} continueToSubmit
         */
        function submitEmailValidation(emailValidationUrl) {
            var continueToSubmit = false;

            $.ajax({
                url: emailValidationUrl,
                type: 'POST',
                async: false,
                success: function (responseData) {
                    if (responseData.success) {
                        continueToSubmit = true;
                    } else {
                        var emailSelector = '.shipping-address-block .shippingEmail';
                        $('.error-message').show();
                        $('.error-message-text').text(responseData.message);
                        $.spinner().stop();
                        scrollAnimate($(emailSelector));
                        // enable the next:Payment button here
                        $('body').trigger('checkout:enableButton', '.next-step-button button');
                    }
                },
                error: function () { // If we don't get a 200 response from the API call
                    // enable the next:Payment button here
                    $('body').trigger('checkout:enableButton', '.next-step-button button');
                    $.spinner().stop();

                    continueToSubmit = true;
                }
            });

            return continueToSubmit;
        }

        //
        // Local member methods of the Checkout plugin
        //
        var members = {

            // initialize the currentStage variable for the first time
            currentStage: 0,

            /**
             * Set or update the checkout stage (AKA the shipping, billing, payment, etc... steps)
             * @param {Event} e Event
             * @returns {Object} a promise
             */
            updateStage: function (e) {
                var stage = checkoutStages[members.currentStage];
                var defer = $.Deferred(); // eslint-disable-line

                if (stage === 'shipping') {
                    //
                    // Submit the Shipping Address Form
                    //
                    var isMultiShip = $checkoutMain.hasClass('multi-ship');
                    var isShipTo = $('.copy-shipping-form');
                    var formSelector = isMultiShip
                        ? '.multi-shipping .active form' : '.single-shipping .shipping-form';
                    if (isMultiShip && isShipTo) {
                        formSelector = '.multi-shipping .copy-shipping-form';
                    }

                    var form = $(formSelector);
                    var $shippingSummary = $('.shipping-summary');
                    var $shippingSummaryHeader = $shippingSummary.length ? $shippingSummary.find('.card-header') : null;
                    var $shippingAddressBlock = $(formSelector).find('.shipping-address-block');

                    // If Yamato Pickup is selected for shipping, COD should be disabled
                    preventYamatoCOD();

                    //
                    // Clear Previous Errors
                    //
                    formHelpers.clearPreviousErrors('.shipping-form');
                    if (isMultiShip && form.length === 0) {
                        // disable the next:Payment button here
                        $('body').trigger('checkout:disableButton', '.next-step-button button');
                        // in case the multi ship form is already submitted
                        var url = $checkoutMain.attr('data-checkout-get-url');
                        $.ajax({
                            url: url,
                            method: 'GET',
                            success: function (data) {
                                // enable the next:Payment button here
                                $('body').trigger('checkout:enableButton', '.next-step-button button');
                                if (!data.error) {
                                    $('body').trigger('checkout:updateCheckoutView',
                                        { order: data.order, customer: data.customer });
                                    if ($shippingSummaryHeader) {
                                        scrollAnimate($shippingSummaryHeader);
                                    }
                                    defer.resolve();
                                } else if (data.message && $('.shipping-error .alert-danger').length < 1) {
                                    var errorMsg = data.message;
                                    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                                        + 'fade show" role="alert">'
                                        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                                        + '<span aria-hidden="true">&times;</span>'
                                        + '</button>' + errorMsg + '</div>';
                                    $('.shipping-error').append(errorHtml);
                                    scrollAnimate($('.shipping-error'));
                                    defer.reject();
                                } else if (data.redirectUrl) {
                                    window.location.href = data.redirectUrl;
                                }
                            },
                            error: function () {
                                // enable the next:Payment button here
                                $('body').trigger('checkout:enableButton', '.next-step-button button');
                                // Server error submitting form
                                defer.reject();
                            }
                        });
                    } else {
                        var shippingFormData = form.serialize();
                        var isShippingFormValid = clientSideValidation.functions.validateClientForm($(formSelector)[0], e);
                        var isShippingFieldsVisible = $shippingAddressBlock.length && $shippingAddressBlock.is(':visible') && $shippingAddressBlock.find('[name$="_address1"]').is(':visible');
                        var isBossShipping = !!$('.shipping-type-boss').length;
                        var isBossSelected = !!$('.boss-store-list').length && !!$('.boss-store.store-selected').length;
                        var isEmailValid = !$('#shippingEmail').hasClass('is-invalid');
                        if (((isShippingFormValid && !isBossShipping) || (isShippingFormValid && isBossShipping && isBossSelected)) || (!isShippingFormValid && !isShippingFieldsVisible && isEmailValid)) {
                            formHelpers.clearPreviousErrors('.shipping-form');
                            $('body').trigger('checkout:serializeShipping', {
                                form: form,
                                data: shippingFormData,
                                callback: function (data) {
                                    shippingFormData = data;
                                }
                            });

                            var saveShippingAddr = $('.js-save-shipaddress').is(':checked');
                            shippingFormData = shippingFormData + '&saveShippingAddr=' + saveShippingAddr;

                            if ($(plugin).data('editshippingfromreview')) {
                                shippingFormData += '&editshippingfromreview=true';
                            }

                            var submitShippingURL = form.attr('action');
                            submitShippingURL = $('#checkout-main').hasClass('bopis-only-order') ? submitShippingURL += '?isBopisOnlyOrder=true' : submitShippingURL;

                            // disable the next:Payment button here
                            $('body').trigger('checkout:disableButton', '.next-step-button button');
                            $.spinner().start();

                            var continueToSubmit = true;
                            var emailValidationUrl = $('#emailValidationUrl').val();
                            if (emailValidationUrl) {
                                emailValidationUrl = emailValidationUrl + '?Email=' + encodeURIComponent($('#shippingEmail').val());
                                continueToSubmit = submitEmailValidation(emailValidationUrl);
                            }

                            var addressVerifyUrl = $('#addressVerifyUrl').val();
                            var addressNeedsVerification = $(shippingAddressOneLoqate).attr('data-address-needs-verification') === 'true';
                            if (continueToSubmit && isShippingFormValid && addressNeedsVerification && addressVerifyUrl) {
                                continueToSubmit = loqateAddress.submitAddressValidation(addressVerifyUrl, shippingFormData, true);
                            }

                            if (continueToSubmit) {
                                callSubmitShippingURL(submitShippingURL, shippingFormData, isShippingFieldsVisible, $shippingSummaryHeader, defer);
                            }
                        } else {
                            // If shipping fields are not visible, user will not see field-level validation errors
                            // Display a generic error message instead
                            if (!isShippingFieldsVisible) {
                                $('.error-message').show();
                                $('.error-message-text').text($('#addressValidationMessage').val());
                            }
                            if ($('.boss-store-list').length && $('.shipping-type-boss').length && $('.boss-store.store-selected').length === 0) {
                                $('#bossShipToStoreError').show();
                                var scrollPosition = $('.boss-store-list').first().offset().top;
                                $(window).scrollTop(scrollPosition - 110);
                            } else {
                                clientSideValidation.functions.scrollToErrorInPage($(e.currentTarget), $('.shipping-form'));
                            }
                        }
                    }
                    return defer;
                }
                if (stage === 'payment') {
                    //
                    // Submit the Billing Address Form
                    //
                    var isValidForm = true;
                    var CARD_MAESTRO = 'maestro';
                    var $billingAddress = $('.billing-address');
                    var $securityCodeError = $('#securityCodeErrorMsg');
                    var securityCodeErrorMsg = $securityCodeError.val();
                    var securityCodeMaestroErrorMsg = $securityCodeError.data('maestroSecurityCodeErrorMsg');
                    var $savedSelectedCard = $('.selected-card-display');
                    var isBillingFieldsVisible = $billingAddress.length && $billingAddress.is(':visible');
                    formHelpers.clearPreviousErrors('.payment-form');
                    if ($savedSelectedCard.length && $savedSelectedCard.is(':visible')) {
                        // Prevent ajax request untill CVV entered.
                        var $savedPaymentSecurityCode = $savedSelectedCard.find('.show-cvv-input .saved-payment-security-code');

                        if ($savedPaymentSecurityCode.length && !$savedPaymentSecurityCode.val()) {
                            $savedPaymentSecurityCode.addClass('is-invalid');
                            if (window.ccType === CARD_MAESTRO) {
                                $savedSelectedCard.find('.show-cvv-input .invalid-feedback.security-code').html(securityCodeMaestroErrorMsg).show();
                            } else {
                                $savedSelectedCard.find('.show-cvv-input .invalid-feedback.security-code').html(securityCodeErrorMsg).show();
                            }
                            scrollAnimate($savedPaymentSecurityCode);
                            return false;
                        }
                    }

                    if (!$billingAddress.hasClass('d-none')) {
                        isValidForm = clientSideValidation.functions.validateClientForm($billingAddress[0], e, true);
                        if (!isValidForm) {
                            // If billing fields are not visible, user will not see address errors
                            // Display a generic error message instead
                            if (!isBillingFieldsVisible) {
                                $('.error-message').show();
                                $('.error-message-text').text($('#addressValidationMessage').val());
                            }
                            clientSideValidation.functions.scrollToErrorInPage($(e.currentTarget), $billingAddress);
                            return false;
                        }
                    }

                    var $peachForm = $('form.wpwl-form-card');
                    if ($('[name="dwfrm_billing_paymentMethod"]').val() === 'PEACH_CAP') {
                        $peachForm.show();
                    } else {
                        $peachForm.hide();
                    }

                    if (isValidForm) {
                        var billingAddressForm = $('#dwfrm_billing .billing-address-block :input').serialize();
                        var $billingAddressBlock = $('#dwfrm_billing .billing-address-block');
                        var $contactInfoBlock = $('#dwfrm_billing .contact-info-block');

                        if ($billingAddressBlock.length) {
                            $('body').trigger('checkout:serializeBilling', {
                                form: $billingAddressBlock,
                                data: billingAddressForm,
                                callback: function (data) {
                                    if (data) {
                                        billingAddressForm = data;
                                    }
                                }
                            });
                        }

                        var contactInfoForm = $('#dwfrm_billing .contact-info-block :input').serialize();

                        if ($contactInfoBlock.length) {
                            $('body').trigger('checkout:serializeBilling', {
                                form: $contactInfoBlock,
                                data: contactInfoForm,
                                callback: function (data) {
                                    if (data) {
                                        contactInfoForm = data;
                                    }
                                }
                            });
                        }

                        var unsavedCard = false;
                        if ($('#new-unsaved').is(':checked')) {
                            unsavedCard = true;
                        }

                        var activeTabId = $('.tab-pane.active').attr('id');
                        var paymentInfoSelector = '#dwfrm_billing .' + activeTabId + ' .payment-form-fields :input';
                        var paymentInfoForm = $(paymentInfoSelector).serialize();

                        $('body').trigger('checkout:serializeBilling', {
                            form: $(paymentInfoSelector),
                            data: paymentInfoForm,
                            callback: function (data) {
                                if (data) {
                                    paymentInfoForm = data;
                                }
                            }
                        });

                        var addressId = $('.billing-information').attr('data-address-mode');
                        if (addressId !== 'new') {
                            addressId = $('.custom-dropdown.billingAddressSelector .billing-dropdown option:selected').val();
                        }

                        // Loyalty form data
                        var loyaltyForm = $('#loyalty-point-card-block :input').serialize();

                        var paymentForm = billingAddressForm + '&' + contactInfoForm + '&' + paymentInfoForm + '&addressId=' + addressId + '&' + loyaltyForm;
                        var $selectedCard = $('.selected-card-display');
                        // eslint-disable-next-line sonarjs/no-collapsible-if
                        if ($('.data-checkout-stage').data('customer-type') === 'registered') {
                            // if payment method is credit card
                            if ($('.payment-information').data('payment-method-id') === 'CREDIT_CARD') {
                                var cvvCode = $selectedCard.find('.saved-payment-security-code').val();
                                if (!($('.payment-information').data('is-new-payment')) && !unsavedCard) {
                                    var $savedPaymentInstrument = $('.saved-payment-instrument'
                                        + '.selected-payment');

                                    paymentForm += '&storedPaymentUUID='
                                        + $savedPaymentInstrument.data('uuid');

                                    paymentForm += '&securityCode=' + cvvCode;
                                } else if (unsavedCard) {
                                    var $unsavedCard = $('li.unsaved-card');
                                    paymentForm += '&unsavedCard=' + unsavedCard + '&unsavedCC=' + $unsavedCard.data('cc-number')
                                        + '&unsavedExpMonth=' + $unsavedCard.data('exp-month')
                                        + '&unsavedExpYear=' + $unsavedCard.data('exp-year') + '&unsavedCVV=' + cvvCode
                                        + '&unsavedCardType=' + $unsavedCard.data('credit-card-type');
                                }
                            }
                        }

                        // AmazonPay Code
                        var selectedPaymentMethod = $('[name="dwfrm_billing_paymentMethod"]').val();
                        sessionStorage.setItem('paymentMethodId', selectedPaymentMethod);
                        // AmazonPay Code

                        // disable the next:Place Order button here
                        $('body').trigger('checkout:disableButton', '.next-step-button button');
                        $.spinner().start();
                        $.ajax({
                            url: $('#dwfrm_billing').attr('action'),
                            method: 'POST',
                            data: paymentForm,
                            success: function (data) {
                                import(/* webpackPrefetch: true */'../zipCodes').then(function (zipCodes) {
                                    // enable the next:Place Order button here
                                    $('body').trigger('checkout:enableButton', '.next-step-button button');
                                    $('.invalid-feedback').each(function () {
                                        $('.invalid-feedback').empty();
                                    });
                                    // look for field validation errors

                                    var postalCode = data.form.addressFields.postalCode ? data.form.addressFields.postalCode.htmlValue : null;
                                    var country = data.form.addressFields.country.htmlValue;
                                    var zipCodeSelector = '.billing-address .dynamic-address-container .billingpostalCode';
                                    var isZipCodeValid = true;
                                    if (country && postalCode) {
                                        isZipCodeValid = utils.isZipCodeValid(postalCode, country, zipCodeSelector, zipCodes.zipCodeJSON);
                                    }

                                    if (!isZipCodeValid) {
                                        // If billing fields are not visible, user will not see zip code error
                                        // Display a generic error message instead
                                        if (!isBillingFieldsVisible) {
                                            $('.error-message').show();
                                            $('.error-message-text').text($('#addressValidationMessage').val());
                                        }
                                        $.spinner().stop();
                                        scrollAnimate($(zipCodeSelector));
                                        return;
                                    }
                                    if (data.error) {
                                        var $creditCardForm = $('.credit-card-form');
                                        if (data.fieldErrors !== undefined && data.fieldErrors.length) {
                                            data.fieldErrors.forEach(function (error) {
                                                var errorObjLength = Object.keys(error).length;
                                                if (errorObjLength) {
                                                    var isPaymentFormVisible = $('.payment-form').is(':visible');
                                                    var isTermsVisible = $('.terms-conditions-content').is(':visible');
                                                    if (isPaymentFormVisible) {
                                                        formHelpers.loadFormErrors('.payment-form', error);
                                                    }

                                                    if (isTermsVisible) {
                                                        formHelpers.loadFormErrors('.terms-conditions-content', error);
                                                    }
                                                    var invalidFields = [];
                                                    $.each(error, function (attr) {
                                                        if (attr.indexOf('securityCode') > -1) {
                                                            if (data.storedPaymentUUID || unsavedCard) {
                                                                if ($selectedCard.length) {
                                                                    $selectedCard.find('.show-cvv-input .saved-payment-security-code').addClass('is-invalid');
                                                                    if (window.ccType === CARD_MAESTRO) {
                                                                        $selectedCard.find('.show-cvv-input .invalid-feedback.security-code').html(securityCodeMaestroErrorMsg).show();
                                                                    } else {
                                                                        $selectedCard.find('.show-cvv-input .invalid-feedback.security-code').html(securityCodeErrorMsg).show();
                                                                    }
                                                                    invalidFields.push('SecurityCode');
                                                                }
                                                                $creditCardForm.find('.credit-card-form .securityCode.is-invalid').removeClass('is-invalid');
                                                                $creditCardForm.find('.invalid-feedback').hide();
                                                            } else {
                                                                if (window.ccType === CARD_MAESTRO) {
                                                                    $creditCardForm.find('#securityCodeInvalidMessage').html(securityCodeMaestroErrorMsg).show();
                                                                } else {
                                                                    $creditCardForm.find('#securityCodeInvalidMessage').html(securityCodeErrorMsg).show();
                                                                }
                                                                invalidFields.push('SecurityCode');
                                                            }
                                                        } else if (attr.indexOf('expirationMonth') > -1 || attr.indexOf('expirationYear') > -1 || attr.indexOf('expMonthYear') > -1) {
                                                            var expiredMessage = data.fieldErrors[0][attr];

                                                            if ($savedSelectedCard.length) {
                                                                $savedSelectedCard.find('#expiredCardMessage').empty();
                                                                $savedSelectedCard.find('#expiredCardMessage').html(expiredMessage).show();
                                                            } else {
                                                                $creditCardForm.find('#expiredCardMessage').empty();
                                                                $creditCardForm.find('#expiredCardMessage').html(expiredMessage).show();
                                                            }

                                                            $creditCardForm.find('.monthYear').addClass('is-invalid');
                                                            if (attr.indexOf('expirationMonth') > -1) {
                                                                invalidFields.push('MM');
                                                            } else if (attr.indexOf('expirationYear') > -1) {
                                                                invalidFields.push('YYYY');
                                                            } else {
                                                                invalidFields.push('MM/YYYY');
                                                            }
                                                        } else {
                                                            $creditCardForm.find('.invalid-feedback').show();
                                                            $creditCardForm.find('#securityCodeInvalidMessage').empty();
                                                            if (attr.indexOf('cardNumber') > -1) {
                                                                invalidFields.push('CreditCardNumber');
                                                            }
                                                        }
                                                    });

                                                    // This will be triggered when there are multiple error fields for credit card form
                                                    if (invalidFields.length) {
                                                        $(document).trigger('credit-card:error', { gaAction: 'Credit Card Error - Submit', gaLabel: invalidFields.join(' | ') });
                                                    }
                                                }
                                            });
                                        }

                                        if (data.serverErrors !== undefined && data.serverErrors.length) {
                                            data.serverErrors.forEach(function (error) {
                                                $('.error-message').show();
                                                $('.error-message-text').text(error);
                                                scrollAnimate($('.error-message'));
                                            });
                                        }

                                        if (data.cartError) {
                                            window.location.href = data.redirectUrl;
                                        }

                                        defer.reject();
                                    } else {
                                        if (activeTabId === 'paypal-content') {
                                            if (!$('.submit-payment').hasClass('d-none')) {
                                                $('.submit-payment').removeClass('d-block').addClass('d-none');
                                                if ($('.paypal-billing-container').length) {
                                                    $('.paypal-billing-container').removeClass('d-none');
                                                }
                                            }
                                        // eslint-disable-next-line sonarjs/no-collapsible-if
                                        } else if (activeTabId !== 'paypal-content') {
                                            if ($('.paypal-billing-container').length) {
                                                $('.paypal-billing-container').addClass('d-none');
                                            }
                                        }

                                        //
                                        // Populate the Address Summary
                                        //
                                        $('body').trigger('checkout:updateCheckoutView',
                                            { order: data.order, customer: data.customer });

                                        if ($('#gift-payment-methods .gc-removed-msg') && $('#gift-payment-methods .gc-removed-msg').length > 0) {
                                            $('#gift-payment-methods .gc-removed-msg').remove();
                                        }

                                        if (data.renderedPaymentInstruments) {
                                            $('.stored-payments').empty().html(
                                                data.renderedPaymentInstruments
                                            );
                                            $('.payment-information').data('is-new-payment', false);
                                            showSavedPaymentInstruments(true);
                                            $('.add-new-card-container').removeClass('checkout-hidden');
                                            billingHelpers.methods.updateSavedCardTemplate();
                                            billingHelpers.methods.handleSavedCardsDropdown();
                                        }

                                        if (!data.customer.registeredUser) {
                                            $('.credit-card-form').removeClass('checkout-hidden');
                                            billingHelpers.methods.clearCreditCardForm();
                                        }

                                        if (data.renderedCheckoutTermsConditions) {
                                            $('#termsConditionsSection').empty().html(
                                                data.renderedCheckoutTermsConditions
                                            );
                                        }

                                        if (data.customer.registeredUser
                                            && data.customer.customerPaymentInstruments.length
                                        ) {
                                            $('.cancel-new-payment').removeClass('checkout-hidden');
                                        }
                                        showTermsConditions();

                                        defer.resolve(data);
                                    }
                                    $.spinner().stop();
                                });
                            },
                            error: function (err) {
                                // enable the next:Place Order button here
                                $('body').trigger('checkout:enableButton', '.next-step-button button');
                                if (err.responseJSON && err.responseJSON.redirectUrl) {
                                    window.location.href = err.responseJSON.redirectUrl;
                                }

                                $.spinner().stop();
                            }
                        });
                    }
                    return defer;
                }
                if (stage === 'placeOrder') {
                    // Redirect to Peach Payment page if attempting to submit after page is refreshed
                    if ($('[name="dwfrm_billing_paymentMethod"]').val() === 'PEACH_CAP' && ($('form.wpwl-form-card').length === 0 || !validatePeachForm($('form.wpwl-form-card')))) {
                        peachCheckout.validateCardNumber(true);
                        peachCheckout.validateExpiry(true);
                        peachCheckout.validateCardHolder(true);
                        peachCheckout.validateSecurityCode(true);
                        return false;
                    }

                    // disable the placeOrder button here
                    $('body').trigger('checkout:disableButton', '.next-step-button button');
                    $('.submit-payment').addClass('d-none');
                    var termsConditionsCheckbox = $('#dwfrm_termsconditions').prop('checked');
                    var billingContainerPaypal = $('.paypal-billing-container');
                    var queryString;

                    if (billingContainerPaypal.length) {
                        var emailId = $('#paypalOrderCustom').val();
                        var paypalTermsandConditions = $('#add-to-email-list-paypal').is(':checked');
                        var isFromCart = true;
                        queryString = '?termsconditions=' + termsConditionsCheckbox + '&email=' + emailId + '&subscription=' + paypalTermsandConditions + '&isFromCart=' + isFromCart;
                        var emailError = $('.paypal-billing-container .invalid-feedback');
                        if (emailError.hasClass('d-block')) {
                            emailError.removeClass('d-block');
                        }
                    } else {
                        queryString = '?termsconditions=' + termsConditionsCheckbox;
                    }
                    clientSideValidation.functions.clearForm('.terms-conditions-content');
                    var kountExampleVerification = $('.kount-selector').serialize();

                    var eft = $('input[name="peacheft"]').length ? '&eft=' + $('input[name="peacheft"]').val() : '';
                    queryString += eft;

                    $.ajax({
                        url: $('.place-order').data('action') + queryString,
                        method: 'POST',
                        data: kountExampleVerification,
                        success: function (data) {
                            if (data.error || data.deco) {
                                $('body').trigger('checkout:enableButton', '.next-step-button button');
                                if (data.fieldErrors !== undefined && data.fieldErrors.length) {
                                    data.fieldErrors.forEach(function (error) {
                                        if (Object.keys(error).length) {
                                            formHelpers.loadFormErrors('.terms-conditions-content', error);
                                        }
                                    });
                                }

                                if (data.errorMessage && billingContainerPaypal.length) {
                                    billingContainerPaypal.find('.invalid-feedback').html(data.errorMessage).addClass('d-block');
                                }

                                if (data.cartError) {
                                    window.location.href = data.redirectUrl;
                                    defer.reject();
                                } else if (data.decoIsEligible) {
                                    var optInURL = data.continueUrl;
                                    /* render deco widget */
                                    $('.deco-widget-container').show();
                                    $('#deco-loading').hide();
                                    $.spinner().stop();
                                    window.drawDecoWidget(function () {
                                        // Ok, call Deco Opt-in
                                        var order = {
                                            order_no: data.orderID,
                                            checkout_id: data.checkoutID
                                        };
                                        $.ajax({
                                            url: optInURL,
                                            data: order,
                                            success: function (response) {
                                                if (response.ok) {
                                                    var submitUrl = response.submitUrl;
                                                    console.log('Order is submitted, redirecting to confirmation. Url: ', submitUrl);
                                                    window.location.assign(submitUrl);
                                                } else {
                                                    $('#deco-widget-status').text(response.message);
                                                }
                                            },
                                            dataType: 'json'
                                        });
                                    });
                                } else {
                                    // go to appropriate stage and display error message
                                    defer.reject(data);
                                }

                                if ($('.terms-cond-checkbox').length) {
                                    $('.terms-cond-checkbox').prop('checked', false);
                                }
                            } else if (data.peachCAP && $('form.wpwl-form-card').length) {
                                var paymentDetails = '<input type="hidden" name="customParameters[SHOPPER_orderID]" value="' + data.orderID + '"/>'
                                    + '<input type="hidden" name="customParameters[SHOPPER_orderToken]" value="' + data.orderToken + '"/>'
                                    + '<input type="hidden" name="customParameters[SHOPPER_subscription]" value="' + data.subscription + '"/>'
                                    + '<input type="hidden" name="customParameters[SHOPPER_fraudStatus]" value="' + data.fraudStatus + '"/>'
                                    + '<input type="hidden" name="customParameters[SHOPPER_fraudStatus]" value="' + data.fraudStatus + '"/>';
                                $('form.wpwl-form-card').append(paymentDetails);
                                submitPeachForm();
                            } else if (data.isPaidy) {
                                $('body').trigger('checkout:paidyPlaceOrder', data);
                            } else if (data.handleAPExpressFlow && data.amzPlaceOrderRedirectUrl) {
                                handleAmazonPayExpressPlaceOrderFlow(data);
                            } else {
                                $('body').trigger('checkout:enableButton', '.next-step-button button');
                                var continueUrl = data.continueUrl;
                                var urlParams = {
                                    ID: data.orderID,
                                    token: data.orderToken
                                };
                                if (data.fraudStatus) {
                                    urlParams.fraudStatus = data.fraudStatus;
                                }
                                if (data.subscription) {
                                    urlParams.subscription = data.subscription;
                                }
                                // ### Custom Adyen cartridge start ###
                                if (data.adyenAction) {
                                    window.orderToken = data.orderToken;
                                    var adyenCheckout = require('../../../../../../../../org_newbalance/cartridges/org_adyen_sfra_custom_v24/cartridge/client/default/js/adyenCheckout');
                                    adyenCheckout.actionHandler(data.adyenAction);
                                    // ### Custom Adyen cartridge end ###
                                } else {
                                    continueUrl += (continueUrl.indexOf('?') !== -1 ? '&' : '?')
                                    + Object.keys(urlParams).map(function (key) {
                                        return key + '=' + encodeURIComponent(urlParams[key]);
                                    }).join('&');
                                    window.location.href = continueUrl;
                                    defer.resolve(data);
                                }
                            }
                        },
                        error: function () {
                            if ($('.terms-cond-checkbox').length) {
                                $('.terms-cond-checkbox').prop('checked', false);
                            }
                            // enable the placeOrder button here
                            $('body').trigger('checkout:enableButton', $('.next-step-button button'));
                        }
                    });

                    return defer;
                }
                var p = $('<div>').promise(); // eslint-disable-line
                setTimeout(function () {
                    p.done(); // eslint-disable-line
                }, 500);
                return p; // eslint-disable-line
            },

            /**
             * Initialize the checkout stage.
             *
             * TODO: update this to allow stage to be set from server?
             */
            initialize: function () {
                // set the initial state of checkout
                members.currentStage = checkoutStages
                    .indexOf($('.data-checkout-stage').data('checkout-stage'));
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
                var $billingAddress = $('.billing-address');
                var $termsConditionsContent = $('.terms-conditions-content');
                var $submitPayment = $('.submit-payment');

                //
                // Handle Payment option selection
                //
                $('input[name$="paymentMethod"]', plugin).on('change', function () {
                    $('.credit-card-form').toggle($(this).val() === 'CREDIT_CARD');
                });

                // Replace the Place Order button with Amazon Additional Pay button
                members.amazonAdditionalButton();

                //
                // Handle Next State button click
                //
                $(plugin).on('click', '.next-step-button button', function (e) {
                    members.nextStage(e);
                });

                //
                // Handle Edit buttons on shipping and payment summary cards
                //
                $('.shipping-summary .edit-button', plugin).on('click', function () {
                    if (!$checkoutMain.hasClass('multi-ship')) {
                        $('body').trigger('shipping:selectSingleShipping');
                    }

                    var billingContainerPaypalShipping = $('.paypal-billing-container');

                    if (billingContainerPaypalShipping.length) {
                        billingContainerPaypalShipping.addClass('d-none');
                    }

                    // If Yamato COD is selected for payment, store pick up should be disabled
                    preventYamatoPickup();

                    // hide checkout credit card payment form
                    $('.cancel-new-payment').trigger('click');

                    if (!$submitPayment.hasClass('d-none')) {
                        $submitPayment.removeClass('d-block').addClass('d-none');
                    }

                    if (members.currentStage === 2) {
                        members.gotoShippingFromReviewStage('shipping');
                        $(plugin).data('editshippingfromreview', true);
                    } else {
                        members.gotoStage('shipping');
                        $(plugin).data('editshippingfromreview', false);
                    }

                    // Remove terms & conditions section if available
                    $termsConditionsContent.addClass('d-none');
                    $submitPayment.addClass('d-none');
                    setTimeout(function () {
                        if ($('.data-checkout-stage').data('customerType') === 'registered') {
                            var isMultiShip = $checkoutMain.hasClass('multi-ship');
                            var $formSelector = isMultiShip
                                ? $('.multi-shipping .active form') : $('.single-shipping .shipping-form');
                            $formSelector.find('.custom-dropdown.shippingAddressSelector .selected-option').trigger('click');
                        }
                    }, 100);

                    if ($pageTitle.length) {
                        $pageTitle.html($pageTitle.data('initialTitle'));
                    }
                });

                $('.payment-summary .edit-button', plugin).on('click', function () {
                    // Remove terms & conditions section if available

                    $(plugin).attr('data-editshippingfromreview', false);
                    var selectedPaymentMethod = $("input[name='selectedPaymentMethod']").val();
                    $('.payment-information').data('payment-method-id', selectedPaymentMethod);
                    var billingContainerPaypalPayment = $('.paypal-billing-container');

                    if (billingContainerPaypalPayment.length) {
                        billingContainerPaypalPayment.addClass('d-none');
                    }
                    $termsConditionsContent.addClass('d-none');
                    if ($pageTitle.length) {
                        $pageTitle.html($pageTitle.data('initialTitle'));
                    }
                    members.gotoStage('payment');

                    // Re initializing tooltip again
                    if ($('[data-toggle="tooltip"]').length) {
                        $('[data-toggle="tooltip"]').tooltip();
                    }
                });

                //
                // remember stage (e.g. shipping)
                //
                updateUrl(members.currentStage);

                //
                // Listen for foward/back button press and move to correct checkout-stage
                //
                $(window).on('popstate', function (e) {
                    //
                    // Back button when event state less than current state in ordered
                    // checkoutStages array.
                    //
                    if (e.state === null
                        || checkoutStages.indexOf(e.state) < members.currentStage) {
                        members.handlePrevStage(false);
                        getShippingMethods();
                    } else if (checkoutStages.indexOf(e.state) > members.currentStage) {
                        // Forward button  pressed
                        members.handleNextStage(false);
                    }
                    if (members.currentStage === 0) {
                        preventYamatoPickup();
                    } else if (members.currentStage === 1) {
                        preventYamatoCOD();
                    }
                });

                //
                // Set the form data
                //
                plugin.data('formData', formData);
                $termsConditionsContent.addClass('d-none');
                var stage = checkoutStages[members.currentStage];
                if (stage === 'placeOrder') {
                    $termsConditionsContent.removeClass('d-none');
                }

                // eslint-disable-next-line sonarjs/no-collapsible-if
                if (stage === 'payment' && $('.billingAddressSelector').length > 0) {
                    if ($billingAddress.length > 0) {
                        $billingAddress.addClass('d-none');
                        var billingEmail = $billingAddress.find('input[name$=_email]');
                        if (billingEmail.length > 0) {
                            billingEmail.val(billingHelpers.methods.getShippingEmail());
                        }
                    }
                }

                if ($('.afterpay-item .afterPayBack').length && $('.afterpay-item .afterPayBack').val() === 'true') {
                    $('.afterpay_pbi-tab').trigger('click');
                    $submitPayment.text($submitPayment.data('afterpay-text'));
                }

                // if there is an error message populated already, show it
                if ($('.error-message-text').html() && $('.error-message-text').html().length > 0) {
                    $('.error-message').show();
                    scrollAnimate($('.error-message'));
                }
            },

            /**
             * @param {Event} e event
             * The next checkout state step updates the css for showing correct buttons etc...
             */
            nextStage: function (e) {
                var promise = members.updateStage(e);

                promise.done(function () {
                    // Update UI with new stage
                    members.handleNextStage(true);

                    // Replace the Place Order button with Amazon Additional Pay button
                    members.amazonAdditionalButton();
                });

                promise.fail(function (data) {
                    // show errors
                    if (data) {
                        if (data.errorStage) {
                            members.gotoStage(data.errorStage.stage);

                            if (data.errorStage.step === 'billingAddress') {
                                var $billingAddressSameAsShipping = $(
                                    'input[name$="_shippingAddressUseAsBillingAddress"]'
                                );
                                if ($billingAddressSameAsShipping.is(':checked')) {
                                    $billingAddressSameAsShipping.prop('checked', false);
                                }
                            }
                        }

                        if (data.errorMessage) {
                            $('.error-message').show();
                            $('.error-message-text').text(data.errorMessage);
                        }
                    }
                });
            },

            /**
             * The next checkout state step updates the css for showing correct buttons etc...
             *
             * @param {boolean} bPushState - boolean when true pushes state using the history api.
             */
            handleNextStage: function (bPushState) {
                if (members.currentStage === 0) {
                    var $paymentSummary = $('.payment-summary');
                    var isOrderTotalGMPCovered = $('#isOrderTotalGMPCovered').val() === 'true';
                    var isOrderFree = $('#isOrderFree').val() === 'true';
                    if (isOrderTotalGMPCovered || isOrderFree) {
                        members.currentStage = 1;
                        $paymentSummary.find('.edit-button, .summary-details.billing, .billing-addr-label, .payment-details').addClass('d-none');
                        showTermsConditions();
                        if (isOrderTotalGMPCovered) {
                            $paymentSummary.find('.payment-method-gmp').removeClass('d-none');
                        } else {
                            $paymentSummary.find('.payment-method-free').removeClass('d-none');
                        }
                    } else {
                        $paymentSummary.find('.edit-button, .summary-details.billing, .billing-addr-label, .payment-details, .payment-container').removeClass('d-none');
                        selectPaymentMethod();
                        $paymentSummary.find('.payment-method-gmp, .payment-method-free, .entire-order-reedemed').addClass('d-none');
                    }
                    if ($('#skipPayment').val() === 'true') {
                        members.currentStage = 1;
                        showTermsConditions();
                    }
                }
                if (members.currentStage < checkoutStages.length - 1) {
                    // move stage forward
                    members.currentStage += 1;

                    //
                    // show new stage in url (e.g.payment)
                    //
                    if (bPushState) {
                        updateUrl(members.currentStage);
                    }
                }

                // Set the next stage on the DOM
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
                $(plugin).trigger('state-changed');
            },

            /**
             * Previous State
             */
            handlePrevStage: function () {
                if (members.currentStage > 0) {
                    // move state back
                    members.currentStage -= 1;
                    updateUrl(members.currentStage);
                }

                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
                $(plugin).trigger('state-changed');

                // Replace the Place Order button with Amazon Additional Pay button
                members.amazonAdditionalButton();
            },

            /**
             * Use window history to go to a checkout stage
             * @param {string} stageName - the checkout state to goto
             */
            gotoStage: function (stageName) {
                members.currentStage = checkoutStages.indexOf(stageName);
                updateUrl(members.currentStage);
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
                $(plugin).trigger('state-changed');

                // Replace the Place Order button with Amazon Additional Pay button
                members.amazonAdditionalButton();
            },

            /**
             * Use window history to go to a checkout stage
             * @param {string} stageName - the checkout state to goto
             * @param {string} fromStage - the checkout stage from which we are coming from
             */
            gotoShippingFromReviewStage: function (stageName) {
                members.currentStage = checkoutStages.indexOf(stageName);
                window.history.pushState(
                    checkoutStages[members.currentStage],
                    document.title,
                    window.location.pathname
                    + '?stage='
                    + checkoutStages[members.currentStage]
                    + '&editshippingfromreview=true'
                    + '#'
                    + checkoutStages[members.currentStage]
                );
                $('.nb-button.submit-shipping').addClass('from-order-review').html($('button.submit-shipping').data('save-continue-text'));
                $(plugin).attr('data-checkout-stage', checkoutStages[members.currentStage]);
            },
            /**
            * Replaces the Place Order button with Amazon Additional Pay button
            *
            * This function checks the current stage of the checkout process. If the stage is 'placeOrder',
            * it replaces the default Place Order button with an Amazon Pay button if the payment method is set to Amazon Pay.
            * If Amazon Pay is disabled, it continues the flow without making any changes.
            */
            amazonAdditionalButton: function () {
                // If Amazon Pay is disabled, skip the Amazon Pay specific functionality
                if (!window.AmazonPayEnabled) {
                    return;
                }

                if (checkoutStages[members.currentStage] === 'placeOrder') {
                    // Check if the payment method is Amazon Pay and the Amazon Pay button exists
                    if (sessionStorage.getItem('paymentMethodId') === 'AMAZON_PAY' && $('.amazon_pay-option-apb').length) {
                        sessionStorage.setItem('placeOrderUrl', $('.place-order').data('action'));
                        $('.place-order').data('action', '#');
                        $('.place-order').closest('div').addClass('d-none');
                        $('#amazon-apb').html('');

                        $.ajax({
                            url: $('#amazon-apb').data('url'),
                            method: 'POST',
                            success: function (data) {
                                $('#amazon-apb').html(data);
                            }
                        });
                    } else if (sessionStorage && sessionStorage.getItem('paymentMethodId') !== 'AMAZON_PAY') {
                        // If the payment method is not Amazon Pay
                        $('#amazon-apb').html('');
                        $('.place-order').closest('div').removeClass('d-none');

                        if (sessionStorage.getItem('placeOrderUrl')) {
                            $('.place-order').data('action', sessionStorage.getItem('placeOrderUrl'));
                        }
                    } else if (sessionStorage) { // Amazon Pay express checkout
                        $('#amazon-apb').html('');
                        $('.place-order').closest('div').removeClass('d-none');

                        var amazonPlaceOrderUrl = $('.amazon_pay-tab').data('amazonpay-placeorderurl');

                        if (sessionStorage.getItem('placeOrderUrl')) {
                            $('.place-order').data('action', amazonPlaceOrderUrl);
                        }

                        sessionStorage.setItem('paymentMethodId', '');
                    }
                } else {
                    // Reset the Place Order button if the checkout stage is not 'placeOrder
                    $('#amazon-apb').html('');

                    if (sessionStorage.getItem('placeOrderUrl')) {
                        $('.place-order').data('action', sessionStorage.getItem('placeOrderUrl'));
                    }
                }
            }
        };

        $('body').on('click', '.select-address-btn', function () {
            $('#addressVerificationModal').modal('hide');

            // If user selects suggested address, copy values into form
            var selected = $('input[name="addressVerification"]:checked').val();
            if (selected === 'suggested') {
                var shippingAddressOne = $('.address-summary-suggested .address1').data('val');
                var shippingAddressTwo = $('.address-summary-suggested .address2').data('val');
                var shippingAddressCity = $('.address-summary-suggested .city').data('val');
                var shippingState = $('.address-summary-suggested .stateCode').data('val');
                var shippingZipCode = $('.address-summary-suggested .postalCode').data('val');
                var shippingCountry = $('.shippingCountry').val();
                if (shippingCountry === 'HK' || shippingCountry === 'MO') {
                    $('#shippingAddressTwo').val(shippingAddressOne).data('suggestion', shippingAddressOne);
                    $(shippingAddressOneLoqate).val(shippingAddressTwo).data('suggestion', shippingAddressTwo);
                    if (loqateAddress.isTextMode()) {
                        $('#shippingAddressCityText').val(shippingAddressCity).data('suggestion', shippingAddressCity);
                        $('#shippingStateText').val(shippingState).data('suggestion', shippingState);
                    }
                } else {
                    $(shippingAddressOneLoqate).val(shippingAddressOne).data('suggestion', shippingAddressOne);
                    $('#shippingAddressTwo').val(shippingAddressTwo).data('suggestion', shippingAddressTwo);
                }
                $('#shippingAddressCity').val(shippingAddressCity).data('suggestion', shippingAddressCity);
                $('#shippingState').val(shippingState).data('suggestion', shippingState);
                $('#shippingZipCode').val(shippingZipCode).data('suggestion', shippingZipCode);
                $('#manualBypassAddressValidation').val('false');
            } else {
                // Set a flag if the user continues with their manually entered address.
                // We don't need to update the shipping address fields because the
                // user is not making any changes to their address at this stage
                $('#manualBypassAddressValidation').val('true');
            }
            $(document).trigger('loqate:address-verification-modal-save', selected); // tracking

            // Clear this, so we know the verification has been done
            $(shippingAddressOneLoqate).attr('data-address-needs-verification', false);

            var advance = $('#advanceToNextStage').val();
            if (advance === 'true') { // Continue submitting
                members.nextStage();
            } else { // Save/update registered user address
                $('.js-update-edited-shipaddress').trigger('click');
            }
        });

        //
        // Initialize the checkout
        //
        members.initialize();

        $(document).on('update:shippingMethodsList', function (e, zipCodeElement) {
            var $shippingForm = $(zipCodeElement).closest('.shipping-form');
            if ($shippingForm.length) {
                shippingHelpers.methods.updateShippingMethodList($shippingForm);
            }
        });

        $(document).on('cancel:updateShippingAddress', function () {
            var $shippingForm = $('.shipping-form');
            if ($shippingForm.length) {
                shippingHelpers.methods.updateShippingMethodList($shippingForm);
            }
        });

        $(document).on('save:updateShippingAddress', function () {
            var $shippingForm = $('.shipping-form');
            if ($shippingForm.length) {
                shippingHelpers.methods.updateShippingMethodList($shippingForm);
            }
        });

        $('button[value="submit-shipping"]').on('click', function () {
            $(document).trigger('update:shipping-info', { elementType: $(this)[0].nodeName, elementText: $(this)[0].outerText });
        });

        $(document).on('click', '#switchToPickup', function () {
            $(document).trigger('checkout:switchToPickup');
        });

        $(document).on('click', '#switchToShipping', function () {
            $(document).trigger('checkout:switchToShipping');
        });

        /**
         * Listen to hash change in URL
         */
        function onCheckoutHashChange() {
            var stage = checkoutStages[members.currentStage];
            var $checkoutFooter = $('.checkout-footer');
            var $checkoutHeader = $('.showMobileplaceorder');
            var $checkoutMobile = $('.showMobilenotplaceorder');
            setTimeout(function () {
                // Scroll to Page Title to review entire order
                if (stage === 'placeOrder' && $pageTitle.length) {
                    $pageTitle.html($pageTitle.data('reviewOrderTitle'));
                    scrollAnimate($pageTitle);
                    if ($checkoutFooter.length) {
                        $checkoutFooter.addClass('place-order-stage');
                        $checkoutHeader.addClass('place-order-stage');
                        $checkoutMobile.addClass('place-order-stage');
                        $('.placeOrderShowMobile').appendTo('.placeOrderShow');
                    }
                } else {
                    $checkoutFooter.removeClass('place-order-stage');
                    $checkoutHeader.removeClass('place-order-stage');
                    $checkoutMobile.removeClass('place-order-stage');
                    $('.placeOrderShowMobile').appendTo('.editPlaceOrderReview');
                }
            }, 100);
        }

        $(document).ready(function () {
            $(document).trigger('update:checkout-step', { checkout_step: members.currentStage + 1 });
        });

        klarnaOsm.init();

        /**
         * Listen whenever checkout state changes
         */
        $(plugin).on('state-changed', function () {
            var stage = checkoutStages[members.currentStage];
            if (stage === 'shipping') {
                handleDynamicShippingDropdowns();
            } else if (stage === 'payment') {
                handleDynamicBillingDropdowns();
                selectPaymentMethod();
                cvsHelpers.updateBillingFormWithStoreAddress();
            } else {
                $('.submit-payment').addClass('d-none');
            }
            $(document).trigger('update:checkout-step', { checkout_step: members.currentStage + 1 });
            onCheckoutHashChange();
        });

        var stage = checkoutStages[members.currentStage];
        if (stage === 'shipping') {
            handleDynamicShippingDropdowns();
        }
        if (stage === 'payment') {
            handleDynamicBillingDropdowns();
            cvsHelpers.updateBillingFormWithStoreAddress();
        }
        /**
         * This will invoke for payments done through the
         * third party payment options like (PayPal, AfterPay, ApplePay)
         */
        $(window).on('hashchange', function () {
            onCheckoutHashChange();
        }).trigger('hashchange');

        /**
         * This will give focus to the first form field of a payment method when selected
         */
        $('.payment-options .nav-link').on('shown.bs.tab', function () {
            var paymentTab = $(this).attr('href');
            var $paymentTabContent = $(paymentTab);
            var $firstInput = $(':input:not([type=hidden]):first', $paymentTabContent);
            if ($firstInput.length) {
                $firstInput.trigger('focus');
            }
        });

        return this;
    };
}(jQuery));

var exports = {
    initialize: function () {
        $('#checkout-main').checkout();
        utils.checkForSessionLogout();
        if ($('.afterpay-item .afterPayBack').length && $('.afterpay-item .afterPayBack').val() === 'true') {
            $('.payment-information').data('payment-method-id', $('.payment-options .nav-item.afterpay-item').data('method-id'));
            $('.payment-options[role=tablist] a[data-toggle="tab"]').each(function () {
                var $tabContent = $($(this).attr('href'));
                if (this.className.includes('afterpay_pbi-tab')) {
                    $tabContent.find('input, textarea, select').removeAttr('disabled', 'disabled');
                } else {
                    $tabContent.find('input, textarea, select').attr('disabled', 'disabled');
                }
            });
        }

        // This should only fire when checking out with Paypal from cart, or hard reloading the page once you've reached the placeOrder step, and paypal is the selected payment option
        // eslint-disable-next-line sonarjs/no-collapsible-if
        if ($('.data-checkout-stage').data('checkout-stage') === 'placeOrder' && $('input[name="selectedPaymentMethod"]').val() === 'PayPal') {
            if (!$('.has-bopis-items').length) {
                $('button.place-order').attr('disabled', true);
                shippingHelpers.methods.updateShippingMethodList($('.shipping-form'), true);
            }
        }
    },

    updateCheckoutView: function () {
        $('body').on('checkout:updateCheckoutView', function (e, data) {
            shippingHelpers.methods.updateMultiShipInformation(data.order);
            summaryHelpers.updateTotals(data.order.totals, data.order.shipping, data.order.resources);
            data.order.shipping.forEach(function (shipping) {
                shippingHelpers.methods.updateShippingInformation(
                    shipping,
                    data.order,
                    data.customer,
                    data.options
                );
            });
            billingHelpers.methods.updateBillingInformation(
                data.order,
                data.customer,
                data.options
            );
            billingHelpers.methods.updatePaymentInformation(data.order, data.options);
            summaryHelpers.updateOrderProductSummaryInformation(data.order, data.options);
        });
    },
    loqateAddressSuggestions: function () {
        if ($(shippingAddressOneLoqate).length > 0) {
            loqateKeyboard.initLoqate();
        }
    },
    disableButton: function () {
        $('body').on('checkout:disableButton', function (e, button) {
            $(button).prop('disabled', true);
        });
    },

    enableButton: function () {
        $('body').on('checkout:enableButton', function (e, button) {
            $(button).prop('disabled', false);
        });
    },
    customDropdown: function () {
        var selectedOption = $('.custom-dropdown.shippingAddressSelector .shipping-dropdown option:selected');

        if (selectedOption.val() === 'new') {
            $.each($('.custom-dropdown.shippingAddressSelector').find('select').children(), function (index) {
                if (!$(this).prop('disabled') && index !== 0) {
                    setDefaultValues($(this), 'shipping');
                    $(this).attr('selected', 'selected');
                    return false;
                }
                return true;
            });
        } else {
            setDefaultValues($(selectedOption[0]), 'shipping');
        }

        getDefaultValues();

        addressTypes.forEach(function (addressType) {
            $(document).on('click keydown', '.custom-dropdown.' + addressType + 'AddressSelector .selected-option', function (e) {
                var eventType = e.type;
                var eventKeyCode = e.which || e.keyCode;
                var $selectedOption = $(this);
                var $customSelectionList = $selectedOption.next('.custom-selection-list');
                var list = '';
                var isEnterKeycode = eventKeyCode === utils.ENTER_KEY_CODE;
                if (eventType === 'click' || isEnterKeycode) {
                    e.preventDefault();
                    e.stopPropagation();
                    $.each($selectedOption.closest('.custom-dropdown').find('select').children(), function (index) {
                        var $this = $(this);
                        var first = addressType === 'billing' ? $this.val() !== 'new' : index !== 0;
                        if (!$this.prop('disabled') && first) {
                            var firstName = $this.data('firstName');
                            var lastName = $this.data('lastName');
                            var name = window.sitePrefs.nameOrderFormat === 'lastfirst' ? lastName + ' ' + firstName : firstName + ' ' + lastName;
                            if ($this.prop('selected')) {
                                list += '<li class="pb-md-2 ' + addressType + '-item list-item" data-id="' + index + '" id="' + addressType + '_address_' + index + '" role="option" tabindex="0" aria-selected="true"><div class="custom-radio" data-id="' + index + '"><input type="radio" checked data-id="' + index + '" class="form-check-input" id="selection-item' + index + '" name="select"><label data-id="' + index + '" class="form-check-label shipping-method-option mb-3 ps-4" for="selection-item' + index + '">'
                                    + '<span class="display-name d-block">' + name + '</span>'
                                    + '<span class="address-line">' + formatAddress($this) + '</span>'
                                    + '</label></div></li>';
                            } else {
                                list += '<li class="pb-md-2 ' + addressType + '-item list-item" data-id="' + index + '" id="' + addressType + '_address_' + index + '" role="option" tabindex="0" aria-selected="false"><div class="custom-radio" data-id="' + index + '"><input type="radio" data-id="' + index + '" class="form-check-input" id="selection-item' + index + '" name="select"><label data-id="' + index + '" class="form-check-label shipping-method-option mb-3 ps-4" for="selection-item' + index + '">'
                                    + '<span class="display-name d-block">' + name + '</span>'
                                    + '<span class="address-line">' + formatAddress($this) + '</span>'
                                    + '</label></div></li>';
                            }
                        } else if ($this.prop('disabled') && addressType === 'billing') {
                            list += '<legend class="address-group-heading font-body font-weight-semibold pb-3 pb-lg-4 mb-0">' + $this.text() + '</legend>';
                        }
                    });
                    $('.add-update-address').toggleClass('d-none');
                    $selectedOption.toggleClass('active');
                    $customSelectionList.empty().append(list).addClass('active');
                    if (isEnterKeycode) {
                        focusSelectedOption($selectedOption);
                    }
                    if ($selectedOption.hasClass('active')) {
                        $selectedOption.attr('aria-expanded', true);
                    } else {
                        $selectedOption.attr('aria-expanded', false);
                    }
                }
            });

            $(document).on('keydown', '.custom-dropdown.' + addressType + 'AddressSelector .custom-selection-list li, .stored-payments li', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var keyCode = e.which || e.keyCode;
                var $target = $(e.currentTarget);
                switch (keyCode) {
                    case utils.DOWN_ARROW_KEY_CODE:
                        onListItemKeyDown($target, true);
                        break;
                    case utils.UP_ARROW_KEY_CODE:
                        onListItemKeyDown($target, false);
                        break;
                    case utils.ESC_KEY_CODE:
                        closeCustomList($target);
                        break;
                    default:
                        return false;
                }
                return false;
            });
        });
    },
    updateSelectionDropdown: function () {
        $(document).on('click keydown', '.shipping-item, .billing-item', function (e) {
            var $currentTarget = $(e.currentTarget);
            if ($currentTarget.hasClass('shipping-item')) {
                updateSelectedAddress(e, 'shipping');
            } else if ($currentTarget.hasClass('billing-item')) {
                updateSelectedAddress(e, 'billing');
            }
        });

        $('body').on('click', '.edit-billing', function (e) {
            e.preventDefault();
            getDefaultValues();
            billingHelpers.methods.clearCreditCardForm();
            if (!$('#shippingAddressUseAsBillingAddress').is(':checked')) {
                $('.billing-address').removeClass('d-none').addClass('d-block');
                $('.js-billingAddressSelector').addClass('d-none');
            } else {
                $('#shippingAddressUseAsBillingAddress').trigger('change');
                $('.billing-address').addClass('d-none').removeClass('d-block');
                $('.js-billingAddressSelector').removeClass('d-none');
            }
            if (window.sitePrefs.adyenEnabled) {
                var adyenCheckout = require('../../../../../../../../org_newbalance/cartridges/org_adyen_sfra_custom_v24/cartridge/client/default/js/adyenCheckout');
                adyenCheckout.renderGenericComponent();
            }
        });
    },
    changeAddress: function () {
        var addressTypesArr = ['shipping', 'billing']; // This changes is explicitly required for billing address.
        addressTypesArr.forEach(function (addressType) {
            var selector = '';
            if (addressType === 'shipping') {
                selector = '.' + addressType + '-dropdown';
            } else if (addressType === 'billing') {
                selector = '#billingAddressSelector';
            }
            $('body').on('change', selector, function () {
                var selectedOption = $('.' + addressType + '-dropdown option:selected');
                if (selectedOption.val() !== 'new') {
                    setDefaultValues(selectedOption, addressType);
                }
            });
        });
    },
    closeDropdown: function () {
        $('body').on('click', function (e) {
            var currentDiv = $('.custom-dropdown');
            if (currentDiv.has(e.target).length === 0) {
                $('.custom-dropdown .selected-option').removeClass('active');
            }
        });
    },
    getCardDetails: function () {
        billingHelpers.methods.updateSavedCardTemplate();
    },
    changeCard: function () {
        $('body').on('click keydown', '.selected-card-display', function (e) {
            var eventType = e.type;
            var eventKeyCode = e.which || e.keyCode;
            var isEnterKeycode = eventKeyCode === utils.ENTER_KEY_CODE;
            var $selectedCard = $(this);
            if (eventType === 'click' || isEnterKeycode) {
                var totalSavedCards = $('.stored-payments').children('.saved-payment-instrument').length;
                // Prevent click when user has only one saved card
                if (totalSavedCards && totalSavedCards === 1) {
                    return;
                }
                $(this).toggleClass('active');
                // $('.stored-payments .saved-payment-instrument.selected-payment').addClass('d-none');
                $('.stored-payments .saved-payment-instrument.selected-payment').children('input.form-check-input').attr('checked', true);
                if ($('.cvv-add-card').hasClass('checkout-hidden')) {
                    $('.cvv-add-card').removeClass('checkout-hidden');
                }
                formHelpers.clearPreviousErrors('.payment-form');
                $('.credit-card-form').addClass('checkout-hidden');
                // $('.saved-payment-instrument.show-cvv-input.selected-payment').addClass('d-none');
                $.each($('.stored-payments').children(), function () {
                    if (!$(this).hasClass('selected-payment')) {
                        $(this).removeClass('d-none');
                    }
                });

                if (isEnterKeycode) {
                    focusSelectedOption($selectedCard);
                }

                if ($(this).hasClass('active')) {
                    $(this).attr('aria-expanded', true);
                } else {
                    $(this).attr('aria-expanded', false);
                }
            }
        });

        $('.selected-card-display').on('click keydown focus', '.saved-payment-security-code', function (e) {
            e.stopPropagation();
            $('.selected-card-display').removeClass('active');
        });
    },
    taxToolTip: function () {
        var $taxInfoToolTip = $('.tax-info-tip');
        setTimeout(function () {
            if ($taxInfoToolTip.tooltip) {
                var data = $('.tax-information').html();
                $taxInfoToolTip.attr('data-original-title', data);
            }
        }, 2000);
    },
    LoginOrRegiser: function () {
        $('body').on('click', '.newbalance-btn, .login-btn', function () {
            if ($(this).hasClass('login-btn')) {
                $(document).trigger('login-modal-open', ['login_shipping_popupin', 'checkout']);
            } else {
                $(document).trigger('login-modal-open', ['createAccount_shipping_popup', 'checkout']);
            }
            var uniqueCheckoutId = document.getElementById('unique-id-checkout');
            if (uniqueCheckoutId) {
                $(uniqueCheckoutId).modal('show')
                    .find('.modal-body').spinner()
                    .start();
                loadUrl(uniqueCheckoutId).then(function () {
                    // login.OAuthConsentInit();
                    $.spinner().stop();
                });
            }
        });

        /**
         * Function to Display login section in Checkout pages Below the Shipping methods
         * @param {string} param - custom dropdown changes
         * @returns {void}
        */
        function loadCheckoutData(param) {
            $('html, body').animate({ scrollTop: $('#checkoutLoginGuest').offset().top }, 'slow');
            $('#showMobileCheckout').collapse('show');
            $('#loginCheckout').hide();
            $('#registerCheckout').hide();
            if (param === 'login') {
                $('#loginCheckout').show();
            } else if (param === 'register') {
                $('#registerCheckout').show();
            }
        }

        /**
         * Function to Display login section in Checkout pages
         * @param {string} param - custom dropdown changes
         * @returns {void}
        */
        function checkoutLoginEmbed(param) {
            var $mobilecheckoutCont = $('#showMobileCheckout');
            var uniqueCheckoutId = $mobilecheckoutCont[0];
            if ($mobilecheckoutCont.find('.js-load-url').is(':empty')) {
                $mobilecheckoutCont.spinner().start();
                loadUrl(uniqueCheckoutId).then(function () {
                    loadCheckoutData(param);
                    $mobilecheckoutCont.spinner().stop();
                });
            } else {
                loadCheckoutData(param);
            }
        }

        $('body').on('click', '#checkoutLoginEmbed, #guestLoginCheckout, #guestRegisterCheckout', function (e) {
            var param = $(e.currentTarget).attr('data-show-form');
            checkoutLoginEmbed(param);
        });

        $('body').on('click', '.registerCheck', function () {
            $('.cheoutLogin').hide();
            $('.cheoutRegister').show();
        });

        $('body').on('click', '.signIncheckout', function () {
            $('.cheoutLogin').show();
            $('.cheoutRegister').hide();
        });
    },
    setCCDate: function () {
        var $monthYear = $('#monthYear');
        $monthYear.on('blur', function (e) {
            var currTarget = e.currentTarget;
            var ccExpiryDate = currTarget.value.split('/');
            var $form = $(currTarget.form);
            var $expMonth = $form.find('#expirationMonth');
            var $expYear = $form.find('#expirationYear');

            $expMonth.val(ccExpiryDate[0]);
            $expYear.val(ccExpiryDate[1]);
        });
    },
    addSlash: function () {
        var $monthYear = $('#monthYear');
        $monthYear.on('keyup', function (e) {
            this.value = this.value.replace(/[^0-9/.]/g, '').replace(/(\..*)\./g, '$1');
            if (e.which !== 8) {
                var numChars = $monthYear.val().length;
                if (numChars === 2) {
                    var thisVal = $monthYear.val();
                    thisVal += '/';
                    $monthYear.val(thisVal);
                } else if (numChars > 3) {
                    var nextStr = $monthYear.val().slice(3).replace('/', '');
                    $monthYear.val($monthYear.val().substring(0, 3) + nextStr);
                }
            }
        });
    },
    preventInteractionWithReadOnly: function () {
        $('body').on('click', '[readonly]', function (e) {
            e.preventDefault();
        });
        $('body').on('focus', 'select[readonly]', function () {
            $(this).blur();
        });
    }
};

[billingHelpers, shippingHelpers, addressHelpers].forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        if (typeof library[item] === 'object') {
            exports[item] = $.extend({}, exports[item], library[item]);
        } else {
            exports[item] = library[item];
        }
    });
});

/**
 * Function to toggle apple pay display
 */
function handleApplePayDisplay() {
    var applePayContainer = $('.applepay-content');

    if (applePayContainer.length) {
        var mutationHandler = function (mutationList) {
            var keys = Object.keys(mutationList);
            keys.forEach(function (val) {
                var mutation = mutationList[val];

                if (mutation.type === 'childList') {
                    var addedNodes = mutation && mutation.addedNodes;
                    if (addedNodes.length && $(addedNodes).hasClass('dw-apple-pay-button')) {
                        $('[data-method-id="DW_APPLE_PAY"]').removeClass('d-none').addClass('d-flex').addClass('enable-applepay');
                    }
                }
            });
        };
        var config = { attributes: true, childList: true, subtree: true };
        var observer = new MutationObserver(mutationHandler);
        observer.observe($('.applepay-content')[0], config);
    }
}

/**
 * Determine if we show the express payments container. We need the feature toggle on
 * and at least one payment method enabled.
 */
function handleExpressPayments() {
    const expressPayments = document.getElementById('express-payments');
    const showExpress = expressPayments.getAttribute('data-showexpresspayments') === 'true';

    // is this is not enabled return early.
    if (!showExpress) {
        return;
    }

    // if our site preference is on and at least one method is available display the
    // express payments section
    const payPalAvailable = expressPayments.getAttribute('data-paypalavailable') === 'true';
    const applePayAvailable = expressPayments.getAttribute('data-applepayavailable') === 'true';
    let isApplePayDevice = false;

    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        isApplePayDevice = true;
    }

    const shouldShow = showExpress && (
        payPalAvailable
        || (applePayAvailable && isApplePayDevice)
    );

    expressPayments.style.display = shouldShow ? 'block' : 'none';
}

$(document).ready(function () {
    handleApplePayDisplay();
    handleExpressPayments();
    import('../checkout/oneyOSM');
});

window.addEventListener('load', function () {
    var ourObserver = new MutationObserver(function () {
        $('.hide-allowed-payment #rb_klarna_account').parent().addClass('d-none');
    });
    ourObserver.observe(document.querySelector('#paymentMethodsList'), { childList: true, subtree: true });
});

module.exports = exports;
